import React, { useEffect, useState } from 'react'
import { useSearchParams} from 'react-router-dom';
import { FadeLoader } from 'react-spinners';
import RecallItem from './RecallItem';
import "./style.css"
import axios from 'axios';
const RecallContainer = () => {
    const [searchParams,setSearchParams] = useSearchParams();
    const [chassis,setChassis] = useState("");
    const [loader,setLoader]=useState(true);
    const [recallData,setRecallData] = useState({})
    const [count,setCount]=useState(0)
    const getData = async(ch)=> {
	//const res = await axios.get('https://sms-int.mercedes-benz-japan.jp/SMSWeb_API/api/SMS_API/'+ch+'?username=MWADMIN&password=TVdAZG0hbl8yMDIy')
    const res = await axios.get('https://su8j8y3f1d.execute-api.ap-northeast-1.amazonaws.com/prod/'+ch)
       
        // console.log(res)
        setRecallData(res.data,()=>{console.log(recallData)})
        setLoader(false)
    }

    useEffect(() => {
	let ch=""
        var url=window.location.href.split("?")
        if(url.length<=1){
                               window.location.href="https://www.mercedes-benz.co.jp/passengercars/content-pool/tool-pages/error-pages/page-not-found.html"
        }
        else {
            var p=url[1].split("&")
            var chassis_Present = false
            p.forEach(v => {
                var some=v.split("=");
                if(some[0]=="chassis")
                {
                chassis_Present=true
                if((some.length>1 && some[1].length!=17) || some.length==1){
                // chassis_Present=false
                window.location.href=window.location.origin+"/error.html"
                }
		ch=some[1]
                }
                
            });
            if(!chassis_Present)
            window.location.href="https://www.mercedes-benz.co.jp/passengercars/content-pool/tool-pages/error-pages/page-not-found.html"
            // setRecallData(response)
            console.log(recallData)
            if(chassis_Present){
                getData(ch)
                
            if(recallData){
                console.log(recallData)
               
            }
        }
         }
    }, [])
    useEffect(() => {
        setCount(recallData.count,()=>{console.log(count)})
        console.log(recallData)
    }, [recallData])
    
    
  return (
    <div className='recall-container'>
        {
            loader ?
            <div className='spinner'>
            <FadeLoader/>
            </div>
            :
            <div className='recall-data'>
            <div className='recall-title'>リコール検索結果</div>
            {
                count>0?
                <div>
            <div className='recall-lable'>入力された車台番号のお車は下記対策をお受けいただいておりません。</div>
            <div className='chassis-details'>
            <div className='chassis-title'>車台番号 :</div> <div className='chassis-no'> {recallData.chassis}</div>
            </div>
            <div className='recall-lable'>下記の改善措置（リコール等）をクリックして、詳細をご確認ください。</div>
            <div className='recall-list'>
                <ul>
                    {
                        recallData.Recalls?.map((item)=>(
                            <li className='recall-item'>
                            
                            <RecallItem item={item}/>
                            </li> 
                            
                        ))
                    }

                </ul>
            </div>
            
            </div>
            :
            <div>
            <div className='recall-lable'>入力された車台番号のお車は改善措置（リコール等）の対象車両ではありません。</div>
            <div className='chassis-details'>
            <div className='chassis-title'>車台番号 :</div> <div className='chassis-no'> {recallData.chassis}</div>
            </div>
            </div>
            }
            <div className='recall-footer'>
                <div className='recall-lable'>リコールの発表翌日以降より、対象車両の検索が可能となります。</div>
            </div>
        </div>
            }
            
    </div>
  )
}

export default RecallContainer